<template>
  <div class="row">
    <div class="col-md-12">
      <div class="filter-select">
        <vue-select
          :options="microAreas"
          label="micro_area"
          placeholder="Microárea - UBS"
          @input="onChangeMicroArea"
          v-model="selectMicroArea"
        >
          <template slot="option" slot-scope="option">
            {{ option.micro_area }} - {{ option.no_unidade_saude }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="varicela"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :vacinasRegistradas="vacinasRegistradas"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'Varicela',
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  data() {
    return {
      cadastros: [],
      page: 1,
      perPage: 12,
      pages: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      nomeProfissional: '',
      vacinasRegistradas: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      cadastrosOriginais: [],
      setRed: false,
      disabledRed: false,
      disabledGreen: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
      microAreas: [],
      selectMicroArea: '',
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
      this.cadastrosPdf = this.cadastros
    },

    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      setTimeout(() => {
        if (event == true) {
          // mostra os vermelhos
          this.filtros(true, false)
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVermelhos = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      setTimeout(() => {
        if (event == true) {
          // mostra os verdes
          this.filtros(false, true)
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVerdes = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    async vacinasPorCidadao() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (user) {
          this.nomeProfissional = user.data.nome

          // microáreas
          const response_micro_areas = await this.$api.post(
            '/app/acs/microareas',
            {
              co_ibge: this.$store.state.cod_ibge,
              cpf_acs: user.data.cpf,
            }
          )
          this.microAreas = response_micro_areas.data

          //pega a equipe do acs
          const equipe = this.$store.state.equipes.find((el) => {
            return el.nu_ine == this.$store.state.nu_ine
          })
          this.nomeEquipe = equipe.no_equipe

          const microArea = this.microAreas.find((el) => {
            return el.nu_ine == this.$store.state.nu_ine
          })
          this.selectMicroArea = microArea
          const response = await Functions.getDadosPorMicroarea(
            this.$store.state.cod_ibge,
            this.$store.state.nu_ine,
            microArea.micro_area
          )
          this.cadastrosOriginaisEquipe = response
          this.cadastros = response
          this.cadastrosOriginais = response
          this.filtros(true, false)
          this.setRed = true
          this.total_de_registros_da_tabela = response.length
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async onChangeMicroArea(item) {
      if (item != null) {
        this.loading = true
        try {
          const response = await Functions.getDadosPorMicroarea(
            this.$store.state.cod_ibge,
            this.$store.state.nu_ine,
            item.micro_area
          )
          this.cadastros = response
          this.cadastrosOriginais = response
          this.filtros(true, false)
          this.setRed = true
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      } else {
        this.cadastrosOriginais = this.cadastrosOriginaisEquipe
        this.cadastros = this.cadastrosOriginaisEquipe
        this.filtros(true, false)
        this.setRed = true
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        '',
        this.selectMicroArea != null ? this.selectMicroArea.micro_area : ''
      )
    },
  },
  created() {
    this.vacinasPorCidadao()
  },
}
</script>

<style></style>
